import { Button, DialogActions, DialogContent, Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Form, Formik } from "formik";
import * as yup from "yup";
import LabelsContext from "../../../../../../lang/LabelsContext";
import ReviewersService, { ReviewersServiceType } from "../ReviewersService";

export default function ReviewersModal(props: any) {
  const { article, setOpen, setArticle } = props;
  const { saveSuggestedReviewer }: ReviewersServiceType = ReviewersService();
  const { Labels } = LabelsContext();

  const validationSchema = yup.object().shape({
    fullName: yup.string().required(Labels.FULLNAME_REQUIRED),
    email: yup.string().required(Labels.EMAIL_REQUIRED).email(),
  });
  return (
    <DialogContent>
      <Divider />
      <Formik validationSchema={validationSchema} onSubmit={() => {}} initialValues={{ fullName: "", email: "" }}>
        {({ handleBlur, values, touched, errors, handleChange }) => (
          <Form>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  id="fullName"
                  name="fullName"
                  label={Labels.FULLNAME}
                  value={values?.fullName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.fullName && Boolean(errors?.fullName)}
                  helperText={touched?.fullName && errors?.fullName}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  id="email"
                  name="email"
                  value={values?.email}
                  autoComplete="new-password"
                  label={Labels.EMAIL}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched?.email && Boolean(errors?.email)}
                  helperText={touched?.email && errors?.email}
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpen(false);
                }}
                color="primary"
              >
                {Labels.CANCEL}
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  saveSuggestedReviewer(article.id, values, setArticle);
                  setOpen(false);
                }}
              >
                {Labels.ADD}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </DialogContent>
  );
}
